import { FC, useEffect, useState } from "react";
import { SidebarFooter, useSidebar } from "@capacit-com/lara-law-shared-ui";
import { Spinner } from "@capacit-com/lara-law-shared-ui";
import useUsers from "@/hooks/useUsers";
import { User } from "@/models/users/User";
import NavUser from "./nav-user";

const AppSidebarFooter: FC = () => {
  /**** Hooks ****/
  const { useQueryMe } = useUsers();
  const { open } = useSidebar();

  /**** State ****/
  const [user, setUser] = useState<User>();

  /**** Queries ****/
  const fetchMe = useQueryMe();

  /**** Effects ****/
  useEffect(() => {
    if (fetchMe.isFetched && fetchMe.data) {
      setUser(fetchMe.data);
    }
  }, [fetchMe.isFetched, fetchMe.data]);

  return (
    <SidebarFooter className={`${open ? "" : "px-1.5"}`}>
      {!fetchMe.isPending && user ? (
        <NavUser user={user} />
      ) : (
        <div className={`px-2 ${open ? "py-3" : "py-1"}`}>
          <Spinner className="size-6" />
        </div>
      )}
    </SidebarFooter>
  );
};

export default AppSidebarFooter;
